import { Moment } from 'moment';

import { ItemOrderHistoryBase } from 'app/buffer-graph/models/item-order-history/item-order-history-base';

export class ItemOrderHistory extends ItemOrderHistoryBase<ItemOrderHistory> {
    constructor(
        orderId: number,
        date: Moment,
        planArriveDate: Moment,
        order: string,
        distOrder : number,
        status: number,
        statusDesc: string,
        statusDescStyle: number,
        fulfillment: number,
        fulfillmentDesc: string,
        fulfillmentDescStyle: number,
        arrivalDate: Moment,
        arrivedQuantity: number,
        supplierCode: string,
        supplierName: string,
        buffer: number,
        safetyStock: number,
        balance: number,
        inTransit: number,
        need: number,
        hasData: string,
        hasMoq: string,
        hasMoa: string,
        extraAttribute: string,
        isCwh: boolean,
        crossDock: any) {
        super(orderId,
            date,
            planArriveDate,
            order,
            distOrder,
            status,
            statusDesc,
            statusDescStyle,
            fulfillment,
            fulfillmentDesc,
            fulfillmentDescStyle,
            arrivalDate,
            arrivedQuantity,
            supplierCode,
            supplierName,
            buffer,
            safetyStock,
            balance,
            inTransit,
            need,
            hasData,
            hasMoq,
            hasMoa,
            extraAttribute,
            isCwh,
            crossDock);
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history.ts